import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-cm-edit-permission',
  templateUrl: './cm-edit-permission.component.html',
  styleUrls: ['./cm-edit-permission.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CmEditPermissionComponent {

}
